import { getNavBreakpointValue } from "../utilities/breakpoint-helpers";

window.addEventListener('scroll', function() {
	const siteHeader = document.getElementById('top-nav');
	const headerBanner = document.getElementById('pre-nav-banner');
	const body = document.getElementsByTagName('body')[0];
	const navBreakpoint = getNavBreakpointValue();
	const defaultPreNavHeight = 56;
	const preNavWrapper = document.getElementById('pre-nav-wrapper');
	let headerHeight = siteHeader.getBoundingClientRect().height;
	let height;

	if (window.innerWidth >= navBreakpoint) {
		// This value is hardcoded because we want the pre-nav-wrapper height + the padding-top on the nav container BEFORE the user scrolls down or loads the page at a lower Y position.
		// After we've scrolled past this value, the pre-nav-wrapper is positioned beside the main nav rather than on top via flex, which updates the height value, and consequently becomes incorrect.
		// We're doing this so we can use the same search component, and keep it open/closed on scrolling without any interference or jankiness.
		// This is only applicable to screen sizes with the pre-nav-wrapper visible.
		if(preNavWrapper) {
			height = defaultPreNavHeight;
		} else {
			height = 0;
		}
	} else {
		height = headerHeight;
	}

	if(headerBanner) {
		const headerBannerHeight = headerBanner.getBoundingClientRect().height;
		height += headerBannerHeight;
	}

	const scrollTop = this.pageYOffset || document.documentElement.scrollTop;
	if(scrollTop > height){
		if (!siteHeader.classList.contains('fixed-top')) {
			siteHeader.classList.add('fixed-top', 'position-fixed');
			body.style.paddingTop = headerHeight+'px';
		}
	} else if (siteHeader.classList.contains('fixed-top')) {
		siteHeader.classList.remove('fixed-top', 'position-fixed');
		siteHeader.classList.add('position-relative');
		body.style.paddingTop = 0;
	}
});